<template>
	<div>
		<el-carousel height="400px">
			<el-carousel-item v-for="(item, index) in sliders" :key="index">
				<div :style="{backgroundImage: 'url(' + item.img + ')'}" class="slider_img"></div>
			</el-carousel-item>
		</el-carousel>
		<div class="member">
			<h2 class="member-t">低风险高回报的现代小当铺</h2>
			<p class="member-p">助力轻资产运营</p>
			<img class="store-img" src="../../static/cooperate/store.png" alt="" />
		</div>
		<div style="background-color: #fff;">
			<div class="member development-history">
				<div class="member-img" :style="{backgroundImage: 'url(' + require('../../static/cooperate/development-history.png') + ')'}">
					<h2 class="member-t">项目优势</h2>
					<p class="member-p">依托成熟系统与运营经验，打造稳定、高效的业务服务平台</p>
				</div>
			</div>
		</div>
		<div class="cate1">
			<h2 class="cate1-t">业务经营范围</h2>
			<p class="cate1-p">品类寄存与回收服务</p>
			<div class="scroll-container">
				<div class="scroll-content">
					<div class="scroll-item" v-for="(item, i) in cooperate" :key="i">
						<img class="cooperate_item_img" :src="item" alt="" />
					</div>
				</div>
			</div>
		</div>
		<div style="background-color: #fff;">
			<div class="member">
				<h2 class="member-t">服务保障</h2>
				<p class="member-p">看得见的流程，信得过的服务</p>
				<img class="guarantee-img" src="../../static/cooperate/guarantee.png" alt="" />
			</div>
		</div>
		<Saas :flag="'2'"></Saas>
		<ConsultDialog v-if="centerDialogVisible" @close="close"></ConsultDialog>
	</div>
</template>
<script>
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	import ConsultDialog from '@/components/ConsultDialog.vue'
	export default {
		name: 'Index',
		components: {ConsultDialog},
		data() {
			return {
				centerDialogVisible: false,
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
				cooperate: [
					require('../../static/recycle/categories1.png'),
					require('../../static/recycle/categories2.png'),
					require('../../static/recycle/categories3.png'),
					require('../../static/recycle/categories4.png'),
					require('../../static/recycle/categories5.png'),
					require('../../static/recycle/categories6.png'),
					require('../../static/recycle/categories7.png'),
					require('../../static/recycle/categories8.png'),
					require('../../static/recycle/categories9.png'),
					require('../../static/recycle/categories1.png'),
				],
			}
		},
		methods: {},
		mounted() {
			this.sliders = [{
					img: require("../../static/cooperate/banner.png")
				}],
				// 首次加載時，初始化高度
			this.screeWith = window.innerWidth
			this.bannerHeight = 400 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 400 / 1920 * this.screeWith
			}
		},
		methods: {
			close(flag) {
				this.centerDialogVisible = false
			},
			openCode() {
				this.centerDialogVisible = true
			},
		}
	}
</script>

<style scoped>
	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #ff717b !important;
	}

	.border_parent {
		width: 90%;
		margin: auto;
	}

	.banner-item {
		position: relative;
	}

	.left-img-btns {
		margin-top: 20px;
	}

	.btn {
		display: inline-block;
		width: 200px;
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		text-align: center;
		font-weight: 500;
		font-size: 20px;
		cursor: pointer;
	}

	.btn1 {
		color: #FE3D3A;
		background: #FFFFFF;
		margin-right: 20px;
	}

	.btn2 {
		color: #FFFFFF;
		border: 1px solid #FFFFFF;
	}

	.slider_img {
		height: 400px;
		background-size: auto 100%;
		background-repeat: no-repeat;
		background-position: center center;
	}

	.member {
		width: 1200px;
		margin: 0 auto;
		padding-top: 70px;
		padding-bottom: 70px;
	}

	.member-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}

	.member-p {
		font-weight: 600;
		font-size: 12px;
		color: #999999;
		margin-bottom: 50px;
		text-align: center;
		margin-top: 15px;
	}
	
	.member-img {
		width: 1200px;
		margin: 0 auto;
		height: 660px;
		background-size: auto 100%;
		background-repeat: no-repeat;
		background-position: center center;
		padding-top: 70px;
	}
	
	.development-history {
		padding-top: 0 !important;
	}
	.store-img {
		width: 1260px;
		height: 440px;
	}
	.guarantee-img {
		width: 1200px;
		height: 580px;
	}
	.cate1 {
		padding-top: 70px;
		padding-bottom: 70px;
		width: 1520px;
		margin: 0 auto;
	}
	
	.cate1-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}
	.cate1-p {
		font-weight: 600;
		font-size: 12px;
		color: #999999;
		margin-bottom: 50px;
		text-align: center;
		margin-top: 15px;
	}
	/* 合作机构 */
	.scroll-container {
		width: 100%;
		overflow: hidden; /* 隐藏超出容器范围的内容 */
		white-space: nowrap; /* 防止内容换行 */
	}
	.scroll-content {
		display: flex;
		align-items: center;
	    animation: scroll-animation 15s linear infinite; /* 应用动画，15s完成一次滚动，线性速度，无限循环 */
	}
	.scroll-item {
	    display: flex;
		align-items: center;
		justify-content: center;
		background: #FFFFFF;
		border-radius: 8px;
	    margin-right: 40px; /* 滚动项之间的间距 */
	}
	.cooperate_item_img {
		width: 270px;
		height: 270px;
		cursor: pointer;
	}
	@keyframes scroll-animation {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(calc(-100% - 20px)); 
		}
	}
	.member-privilege {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 0;
	}
	.member-img-item {
		position: relative;
	}
	.member-img-item img {
		width: 373px;
	}
	.menber-btn {
		display: inline-block;
		width: 313px;
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		font-weight: 500;
		font-size: 20px;
		text-align: center;
		cursor: pointer;
		position: absolute;
		left: 30px;
		bottom: 50px;
		z-index: 99;
	}
	.menber-btn1 {
		color: #FE3D3A;
		border: 1px solid #FE3D3A;
	}
	.menber-btn1:hover {
		color: #fff;
		background: #FE3D3A;
	}
	.menber-btn2 {
		color: #1684FC;
		border: 1px solid #1684FC;
	}
	.menber-btn2:hover {
		color: #fff;
		background: #1684FC;
	}
	.menber-btn3 {
		color: #3A61FE;
		border: 1px solid #3A61FE;
	}
	.menber-btn3:hover {
		color: #fff;
		background: #3A61FE;
	}
</style>


// WEBPACK FOOTER //
// src/view/cooperate.vue